<ng-container *ngIf="cart">
  <div class="modal-delete-saved-cart modal-fade">
    <div class="header">
      <div class="headline"><span class="headline-text">Eliminar carrito guardado</span></div>
      <button
        class="glyphicon glyphicon-remove cancel"
        (click)="close('Close Delete Cart Dialog')"
        onkeydown="this.blur()"
        tabIndex="0"
      ></button>
    </div>
    <div class="content">
      <p>Los productos actuales en el carrito se guardarán como:</p>
      <div class="modal-details row">
        <span class="col-6">Nombre del carrito:</span>
        <span class="col-6"
          ><b>{{ cart.name }}</b></span
        >
        <span class="col-6">Código del carrito:</span>
        <span class="col-6"
          ><b>{{ cart.code }}</b></span
        >
        <span class="col-6">Cantidad de productos:</span>
        <span class="col-6"
          ><b> {{ cart.totalUnitCount }} </b></span
        >
      </div>
      <div class="modal-actions">
        <div class="row">
          <div class="col-12 col-sm-6 col-sm-pull-6">
            <button (click)="close('Close Delete Cart Dialog')" type="button" class="btn btn-default btn-block">
              Cancelar
            </button>
          </div>
          <div class="col-12 col-sm-6 col-sm-push-6">
            <button type="button" class="btn btn-primary btn-block" (click)="deleteCart(cart.code)">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
